import React, { useState, useRef, useEffect } from "react";
import Icon from "../../../components/AppIcon";

const SortDropdown = ({ currentSort, onSortChange, className = "" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const sortOptions = [
    {
      value: "relevance",
      label: "Best Match",
      description: "Most relevant results",
      icon: "Target",
    },
    {
      value: "newest",
      label: "Newest First",
      description: "Latest arrivals",
      icon: "Clock",
    },
    {
      value: "price-low-high",
      label: "Price: Low to High",
      description: "Lowest price first",
      icon: "TrendingUp",
    },
    {
      value: "price-high-low",
      label: "Price: High to Low",
      description: "Highest price first",
      icon: "TrendingDown",
    },
    {
      value: "rating",
      label: "Top Rated",
      description: "Highest rated first",
      icon: "Star",
    },
    {
      value: "popularity",
      label: "Most Popular",
      description: "Best sellers first",
      icon: "TrendingUp",
    },
    {
      value: "discount",
      label: "Biggest Discount",
      description: "Highest discount first",
      icon: "Percent",
    },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSortSelect = (sortValue) => {
    onSortChange(sortValue);
    setIsOpen(false);
  };

  const getCurrentSortLabel = () => {
    const currentOption = sortOptions.find(
      (option) => option.value === currentSort
    );
    return currentOption ? currentOption.label : "Sort by";
  };

  const getCurrentSortIcon = () => {
    const currentOption = sortOptions.find(
      (option) => option.value === currentSort
    );
    return currentOption ? currentOption.icon : "ArrowUpDown";
  };

  return <div className={`relative ${className}`} ref={dropdownRef}></div>;
};

export default SortDropdown;
